export default function Logo()
{
    return(
        
        <div>

            <div>
                <h1 className="log">Real Estate</h1>
            </div>
        </div>
       
    )
}